import { InverseHeader } from '@jouzen/ecom-components/layout';

import PageLayout from '@/app/components/PageLayout';
import RichText from '@/app/components/RichText';
import { LEGAL_FOOTNOTES_ID } from '@/app/consts/ids';

import HomeRingModules from '../_components/HomeRingsModules';
import useRingCardDataMembership from '../_components/HomeRingsModules/_hooks/useRingCardDataMembership';
import AppTabsSection from './_components-redesign/AppTabsSection';
import AppUpdatesSection from './_components-redesign/AppUpdatesSection';
import FAQSection from './_components-redesign/FAQSection';
import { FeatureCardsAppUI } from './_components-redesign/FeatureCardsAppUI';
import HealthFeaturesSection from './_components-redesign/HealthFeaturesSection';
import MembershipHero from './_components-redesign/MembershipHero';
import MembersSection from './_components-redesign/MembersSection';
import SecuritySection from './_components-redesign/SecuritySection';
import { Testimonials } from './_components-redesign/Testimonials';
import TitleCardHealthJourney from './_components-redesign/TitleCardHealthJourney';
import UIScreens from './_components-redesign/UIScreens';

const ContentRedesign = () => {
  const membershipCardData = useRingCardDataMembership();

  return (
    <PageLayout
      pageName="membership"
      containerProps={{
        className: 'bg-sandstone-200 text-sandstone-500',
        name: 'membership',
        padding: 'none',
      }}
      footnotesProps={{
        className: 'bg-slate-200 text-sandstone-100',
        id: LEGAL_FOOTNOTES_ID,
        footnotes: [
          {
            marker: '*',
            content: (
              <RichText messageKey="footnotes_membership_pricing_updated" />
            ),
          },
        ],
      }}
    >
      <div data-cy="membership-redesign">
        <InverseHeader enter>
          <MembershipHero />
        </InverseHeader>
        <UIScreens />
        <MembersSection />
        <AppTabsSection />
        <HealthFeaturesSection />
        <Testimonials />
        <FeatureCardsAppUI />
        <SecuritySection />
        <FAQSection />
        <TitleCardHealthJourney />
        <InverseHeader enter exit>
          <div className="md:py-10">
            <HomeRingModules membershipRingCardData={membershipCardData} />
          </div>

          <AppUpdatesSection />
        </InverseHeader>
      </div>
    </PageLayout>
  );
};

export default ContentRedesign;
